var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4818 8.1673L9.38553 13.9865C9.03915 14.2983 8.51957 14.2983 8.20783 13.9519C7.89609 13.6055 7.89609 13.0859 8.24247 12.7742L12.8493 8.37513H1.07237C0.587434 8.37513 0.241053 8.02874 0.241053 7.54381C0.241053 7.09351 0.587434 6.71249 1.07237 6.71249H12.8493L8.24247 2.34809C7.89609 2.03634 7.89609 1.48213 8.20783 1.17039C8.51957 0.824007 9.07378 0.824007 9.38553 1.13575L15.4818 6.95496C15.655 7.12815 15.7589 7.33598 15.7589 7.54381C15.7589 7.78628 15.655 7.99411 15.4818 8.1673Z",
    fill: "#262626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.eb4e406f2a8532970bda8d135cd30cc4.svg";
export { ForwardRef as ReactComponent };